import {
    Issue,
    createRegisterableComponentWithData,
    ContentDataDefinitionLoader,
    CollectionDataLoaded,
} from '@news-mono/web-common'
import React, { useContext } from 'react'
import { NightlyPreviousEditions } from './PreviousEditions/NightlyPreviousEditions'

import { MaybeLoaded } from 'json-react-layouts-data-loader'
import { CollectionDataContext } from '../../contexts'

export interface NightlyPreviousEditionsRouteProps {
    latestIssues?: Issue[]
    title: string
    type: 'homepage' | 'editions'
    lazyloadImages?: boolean
}

export const NightlyPreviousEditionsRegistration =
    createRegisterableComponentWithData(
        'nightly-previous-editions',
        ContentDataDefinitionLoader,
        (
            { type, title, lazyloadImages }: NightlyPreviousEditionsRouteProps,
            { dataDefinitionArgs, ...initialData },
            { config },
        ) => {
            const { getCollectionData } = useContext(CollectionDataContext)
            const contextId =
                dataDefinitionArgs.type === 'context'
                    ? dataDefinitionArgs.contextId
                    : undefined

            let data: MaybeLoaded<CollectionDataLoaded> = initialData
            if (contextId) {
                data = getCollectionData(contextId)
            }

            return (
                <NightlyPreviousEditions
                    editions={
                        data.loaded && data.result.kind === 'edition'
                            ? {
                                  loaded: true,
                                  result: data.result.editions,
                              }
                            : { loaded: false }
                    }
                    title={title}
                    type={type}
                    config={config}
                    lazyloadImages={lazyloadImages}
                />
            )
        },
    )
